



























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    components: {}
})
export default class VTreeSelect extends Vue {

    @Prop(Object) extra!: any
    @Prop(Array) secondarySchema!: Array<object>
    @Prop(Object) menuProps!: object
    @Prop(String) label!: string
    @Prop(Array) errorMessages!: Array <object>
    @Prop() value!: any

    elements: Array <object> = []
    result: any = ""
    hasChildren: boolean = false
    isRequired: boolean = false

    normalizer(node: any) {
        return {
            id: node.code,
            label: node.description,
            children: node.children === null ? undefined : node.children
        }
    }

    mounted() {
        setTimeout(() => {
            if (this.value) {
                this.result = this.value;
            }
        }, 1000);
        if(this.extra && this.extra.vvalidate && this.extra.vvalidate === 'required') {
            this.isRequired = true;
        }

        // First we loop over the provided data and check if it has sub elements
        // in the children property
        this.secondarySchema.forEach((sec: any) => {
            if(sec.children && sec.children.length > 0) {
                this.hasChildren = true;
            }
        })

        // then we build one of two structures to store that
        if(this.hasChildren) {
            // this is the multilevel 'tree' select
            this.secondarySchema.forEach((sec: any) => {

                // combine all the children
                let kids: Array <object> = [];
                sec.children.forEach((kid: any) => {
                    kids.push({
                        value: kid.code,
                        text: kid.description,
                        isHeader: false
                    })
                })

                // divider element
                this.elements.push(
                    {
                        divider: true,
                        isHeader: true
                    }
                );
                // this is the parent element - was an optgroup
                this.elements.push({
                    value: sec.code,
                    header: sec.description,
                    isHeader: true
                    //children: kids
                })
                this.elements = this.elements.concat(kids);
            })
        } else {
            // single level drop down select
            // this is just a simple list of options
            this.secondarySchema.forEach((sec: any) => {
                this.elements.push({
                    value: sec.code,
                    text: sec.description,
                    isHeader: false
                })
            })
        }
    }
}

